import Color from 'color'

/**
 * Конвертация цвета из различных форматов в hex с alpha
 * @param colorValue - цвет в любом формате (hex, rgb, название цвета)
 * @param alpha - прозрачность (0-1)
 * @returns hex цвет с alpha каналом (например, "#056FFF80")
 */
export function convertToHexWithAlpha(colorValue: string, alpha = 1): string {
    try {
        const color = Color(colorValue)
        const hex = color.hex()
        const alphaHex = Math.round(alpha * 255)
            .toString(16)
            .padStart(2, '0')
            .toUpperCase()
        return `${hex}${alphaHex}`
    } catch {
        // Если не удалось распарсить цвет, возвращаем черный
        const alphaHex = Math.round(alpha * 255)
            .toString(16)
            .padStart(2, '0')
            .toUpperCase()
        return `#000000${alphaHex}`
    }
}

/**
 * Извлечение alpha канала из hex цвета
 * @param hexWithAlpha - hex цвет с alpha (например, "#056FFF80")
 * @returns объект с hex цветом и alpha (0-1)
 */
export function extractAlphaFromHex(hexWithAlpha: string): {
    hex: string
    alpha: number
} {
    try {
        // Если цвет в формате #RRGGBBAA
        if (hexWithAlpha.length === 9) {
            const hex = hexWithAlpha.slice(0, 7)
            const alphaHex = hexWithAlpha.slice(7, 9)
            const alpha = parseInt(alphaHex, 16) / 255
            return { hex, alpha }
        }
        // Если цвет в формате #RRGGBB
        return { hex: hexWithAlpha, alpha: 1 }
    } catch {
        return { hex: '#000000', alpha: 1 }
    }
}

/**
 * Конвертация hex цвета с alpha в rgba формат для Fabric.js
 * Fabric.js лучше работает с rgba форматом для прозрачности
 * @param hexWithAlpha - hex цвет с alpha (например, "#056FFF80")
 * @returns rgba строка (например, "rgba(5, 111, 255, 0.5)")
 */
export function convertHexWithAlphaToRgba(hexWithAlpha: string): string {
    try {
        const { hex, alpha } = extractAlphaFromHex(hexWithAlpha)
        const color = Color(hex)
        const rgb = color.rgb()
        return `rgba(${rgb.red()}, ${rgb.green()}, ${rgb.blue()}, ${alpha})`
    } catch {
        return 'rgba(0, 0, 0, 1)'
    }
}
